import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {PortailRoutingModule} from './portail-routing.module';
import {PortailComponent} from './portail.component';
import {InputSearchComponent} from './accueil/input-search/input-search.component';
import {ConsulationcardsComponent} from './accueil/consulationcards/consulationcards.component';
import {StatistiquesComponent} from './accueil/statistiques/statistiques.component';
import {DocloisComponent} from './accueil/doclois/doclois.component';
import {ServAssistantComponent} from './accueil/serv-assistant/serv-assistant.component';
import {AccFooterComponent} from './accueil/acc-footer/acc-footer.component';
import {AccueilComponent} from './accueil/accueil.component';
import {SliderImageComponent} from './accueil/slider-image/slider-image.component';
import {WidgetModule} from '../../modules/widget/widget.module';
import {SitesutilesComponent} from './accueil/sitesutiles/sitesutiles.component';
import {OwlModule} from 'ngx-owl-carousel';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MDBBootstrapModule, WavesModule,} from 'angular-bootstrap-md';
import {CarouselModule} from 'primeng/carousel';
import {ButtonModule} from 'primeng';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';
import {DirectiveModule} from '../../modules/directives/directive.module';
import {OffersComponent} from './offers/offers.component';
import {OffersTableComponent} from './offers/offers-table/offers-table.component';
import {OffersFiltreComponent} from './offers/offers-filtre/offers-filtre.component';
import {PipeModule} from 'src/app/modules/pipes/pipe.module';
import {TranslateModule} from '@ngx-translate/core';
import {MatIconModule} from '@angular/material/icon';
import {OfferComponent} from './offers/offer/offer.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatPaginatorModule} from '@angular/material/paginator';
import {QnaService} from 'src/app/modules/services/qna/qna.service';
import {CmisService} from 'src/app/modules/services/cmis/cmis.service';
import {FaqService} from 'src/app/modules/services/faq/faq.service';
import {FournisseurComponent} from './fournisseur/fournisseur.component';
import {
    AddInformationGeneraleFournisseurComponent
} from './fournisseur/inscription-fournisseur/add-information-generale-fournisseur/add-information-generale-fournisseur.component';
import {AddInfoResponsableComponent} from './fournisseur/inscription-fournisseur/add-info-responsable/add-info-responsable.component';
import {AcheteurComponent} from './acheteur/acheteur.component';
import {InscriptionAcheteurComponent} from './acheteur/inscription-acheteur/inscription-acheteur.component';
import {
    AddInfoGeneraleAcheteurComponent
} from './acheteur/inscription-acheteur/add-info-generale-acheteur/add-info-generale-acheteur.component';
import {
    AddInfoInterlocuteurUniqueComponent
} from './acheteur/inscription-acheteur/add-info-interlocuteur-unique/add-info-interlocuteur-unique.component';
import {CmisComponent} from './cmis/cmis.component';
import {CmisTableComponent} from './cmis/cmis-table/cmis-table.component';
import {CmisFiltreComponent} from './cmis/cmis-filtre/cmis-filtre.component';
import {CmisCardComponent} from './cmis/cmis-card/cmis-card.component';
import {FaqComponent} from './faq/faq.component';
import {FaqTableComponent} from './faq/faq-table/faq-table.component';
import {FaqFiltreComponent} from './faq/faq-filtre/faq-filtre.component';
import {FaqCardComponent} from './faq/faq-card/faq-card.component';
import {QnaComponent} from './qna/qna.component';
import {QnaTableComponent} from './qna/qna-table/qna-table.component';
import {QnaFiltreComponent} from './qna/qna-filtre/qna-filtre.component';
import {QnaCardComponent} from './qna/qna-card/qna-card.component';
import {MatStepperModule} from '@angular/material/stepper';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {OfferDetailsComponent} from './offers/offer-details/offer-details.component';
import {LotTableComponent} from './offers/lot-table/lot-table.component';
import {TextEllipsisComponent} from './offers/offers-filtre/text-ellipsis.component';
import {LotDetailsComponent} from './offers/lot-details/lot-details.component';
import {ComboAcheteurComponent} from './offers/combo-acheteur/combo-acheteur.component';
import {ComboCommandeComponent} from './offers/combo-commande/combo-commande.component';
import {ParticipationTableComponent} from './offers/participation-table/participation-table.component';
import {InfoProdTableComponent} from './offers/info-prod-table/info-prod-table.component';

import {ProjetProgComponent} from './projet-prog/projet-prog.component';
import {ProjetProgFiltreComponent} from './projet-prog/projet-prog-filtre/projet-prog-filtre.component';
import {ProjetProgDetailsComponent} from './projet-prog/projet-prog-details/projet-prog-details.component';
import {MatSortModule} from '@angular/material/sort';
import {ProjetProgTableComponent} from './projet-prog/projet-prog-table/projet-prog-table.component';
import {ConsultationsComponent} from './consultations/consultations.component';
import {ConsultationTableComponent} from './consultations/consultation-table/consultation-table.component';
import {ConsultationFiltreComponent} from './consultations/consultation-filtre/consultation-filtre.component';
import {ConsultationDetailsComponent} from './consultations/consultation-details/consultation-details.component';
import {LotConsultationTableComponent} from './consultations/lot-consultation-table/lot-consultation-table.component';

import {NewsCardComponent} from './news/news-card/news-card.component';
import {NewsFiltreComponent} from './news/news-filtre/news-filtre.component';
import {NewsTableComponent} from './news/news-table/news-table.component';
import {NewsComponent} from './news/news.component';
import {NewsService} from 'src/app/modules/services/news/news.service';
import {ContactTerminologieComponent} from './contact-terminologie/contact-terminologie.component';
import {StattunepsService} from 'src/app/modules/services/statestiques/stattuneps.service';
import {ContactService} from 'src/app/modules/services/contact/contact.service';
import {AdminAnnouncementComponent} from './admin-announcement/admin-announcement.component';
import {BuyerAnnouncementComponent} from './buyer-announcement/buyer-announcement.component';
import {BuyerAnnouncementCardComponent} from './buyer-announcement/buyer-announcement-card/buyer-announcement-card.component';
import {BuyerAnnouncementFiltreComponent} from './buyer-announcement/buyer-announcement-filtre/buyer-announcement-filtre.component';
import {BuyerAnnouncementTableComponent} from './buyer-announcement/buyer-announcement-table/buyer-announcement-table.component';
import {AdminAnnouncementCardComponent} from './admin-announcement/admin-announcement-card/admin-announcement-card.component';
import {AdminAnnouncementFiltreComponent} from './admin-announcement/admin-announcement-filtre/admin-announcement-filtre.component';
import {AdminAnnouncementTableComponent} from './admin-announcement/admin-announcement-table/admin-announcement-table.component';
import {TousLesStatistiquesComponent} from './accueil/statistiques/tous-les-statistiques/tous-les-statistiques.component';
import {AnnonceCardsComponent} from './accueil/annonce-cards/annonce-cards.component';

import {FournisseurDetailService} from '../../modules/services/fournisseur/fournisseurdetail.service';
import {FournissuerDetailComponent} from './fournissuer-detail/fournissuer-detail.component';
import {FournisseurTableComponent} from './fournissuer-detail/fournisseur-table/fournisseur-table.component';
import {FournisseurFiltreComponent} from './fournissuer-detail/fournisseur-filtre/fournisseur-filtre.component';
import {AddDialogUsineComponent} from './fournisseur/inscription-fournisseur/add-info-usine/add-dialog-usine/add-dialog-usine.component';
import {TableUsineComponent} from './fournisseur/inscription-fournisseur/add-info-usine/table-usine/table-usine.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {AddInfoUsineComponent} from './fournisseur/inscription-fournisseur/add-info-usine/add-info-usine.component';
import {AddInfoProduitComponent} from './fournisseur/inscription-fournisseur/add-info-produit/add-info-produit.component';
import {ProduitTableComponent} from './fournisseur/inscription-fournisseur/add-info-produit/produit-table/produit-table.component';
import {
    AddDialogProduitComponent
} from './fournisseur/inscription-fournisseur/add-info-produit/add-dialog-produit/add-dialog-produit.component';
import {MatRadioModule} from '@angular/material/radio';
import {AgrementTableComponent} from './fournisseur/inscription-fournisseur/add-info-agrement/agrement-table/agrement-table.component';
import {
    AddDialogAgrementComponent
} from './fournisseur/inscription-fournisseur/add-info-agrement/add-dialog-agrement/add-dialog-agrement.component';
import {
    MandataireTableComponent
} from './fournisseur/inscription-fournisseur/add-info-mandataire/mandataire-table/mandataire-table.component';
import {
    AddDialogMandataireComponent
} from './fournisseur/inscription-fournisseur/add-info-mandataire/add-dialog-mandataire/add-dialog-mandataire.component';
import {LoginComponent} from './login/login.component';
import {MatSelectFilterModule} from 'mat-select-filter';
import {ComboYearsComponent} from './projet-prog/combo-years/combo-years.component';
import {EditDialogUsineComponent} from './fournisseur/inscription-fournisseur/add-info-usine/edit-dialog-usine/edit-dialog-usine.component';
import {
    EditDialogProduitComponent
} from './fournisseur/inscription-fournisseur/add-info-produit/edit-dialog-produit/edit-dialog-produit.component';
import {
    DialogEditAgrementComponent
} from './fournisseur/inscription-fournisseur/add-info-agrement/dialog-edit-agrement/dialog-edit-agrement.component';
import {
    EditDialogMandataireComponent
} from './fournisseur/inscription-fournisseur/add-info-mandataire/edit-dialog-mandataire/edit-dialog-mandataire.component';
import {DetailAgrementComponent} from './fournisseur/inscription-fournisseur/add-info-agrement/detail-agrement/detail-agrement.component';
import {
    DetailMandataireComponent
} from './fournisseur/inscription-fournisseur/add-info-mandataire/detail-mandataire/detail-mandataire.component';
import {CustomDatePipe} from './custom.datepipe';
import {MatExpansionModule} from '@angular/material/expansion';
import {EtatDemandeComponent} from './etat-demande/etat-demande.component';
import {EtatService} from 'src/app/modules/services/etat-demande/etat.service';
import {RecapInscrptionAcheteurComponent} from './acheteur/recap-inscrption-acheteur/recap-inscrption-acheteur.component';
import {
    RecapInfoGeneralAcheteurComponent
} from './acheteur/recap-inscrption-acheteur/recap-info-general-acheteur/recap-info-general-acheteur.component';
import {ComboPmeComponent} from './projet-prog/combo-pme/combo-pme.component';
import {RecapInscriptionFournisseurComponent} from './fournisseur/recap-inscription-fournisseur/recap-inscription-fournisseur.component';
import {
    RecapInfoGeneralFournisseurComponent
} from './fournisseur/recap-inscription-fournisseur/recap-info-general-fournisseur/recap-info-general-fournisseur.component';
import {CataloguePComponent} from './catalogue-p/catalogue-p.component';
import {CataloguePTableComponent} from './catalogue-p/catalogue-p-table/catalogue-p-table.component';
import {CataloguePFiltreComponent} from './catalogue-p/catalogue-p-filtre/catalogue-p-filtre.component';
import {CatalogueService} from 'src/app/modules/services/catalogue/catalogue.service';
import {CatalogueDetailComponent} from './catalogue-p/catalogue-detail/catalogue-detail.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {HierachieClassPComponent} from './hierachie-class-p/hierachie-class-p.component';
import {HierachiePTreeComponent} from './hierachie-class-p/hierachie-p-tree/hierachie-p-tree.component';
import {HierachiePTableComponent} from './hierachie-class-p/hierachie-p-table/hierachie-p-table.component';
import {DetailProdPComponent} from './hierachie-class-p/detail-prod-p/detail-prod-p.component';
import {CatalogueClassPComponent} from './catalogue-class-p/catalogue-class-p.component';
import {CatClasPTableComponent} from './catalogue-class-p/cat-clas-p-table/cat-clas-p-table.component';
import {CatClasPFiltreComponent} from './catalogue-class-p/cat-clas-p-filtre/cat-clas-p-filtre.component';
import {CatClasPDetailComponent} from './catalogue-class-p/cat-clas-p-detail/cat-clas-p-detail.component';
import {CatClasPListComponent} from './catalogue-class-p/cat-clas-p-list/cat-clas-p-list.component';
import {CatClasPListTableComponent} from './catalogue-class-p/cat-clas-p-list/cat-clas-p-list-table/cat-clas-p-list-table.component';
import {FicheListSoumissionairesComponent} from './offers/fiche-list-soumissionaires/fiche-list-soumissionaires.component';
import {TableCommunPortailComponent} from './offers/table-commun-portail/table-commun-portail.component';
import {FicheResultatOuvertureComponent} from './offers/fiche-resultat-ouverture/fiche-resultat-ouverture.component';
import {FicheDetailsRequeteComponent} from './offers/fiche-resultat-ouverture/fiche-details-requete/fiche-details-requete.component';
import {AddCertifFournisseurComponent} from './fournisseur/add-certif-fournisseur/add-certif-fournisseur.component';
import {CertifFournisseurComponent} from './fournisseur/certif-fournisseur/certif-fournisseur.component';
import {
    FilterCertifFournisseurComponent
} from './fournisseur/certif-fournisseur/filter-certif-fournisseur/filter-certif-fournisseur.component';
import {ListFilterCertiffourComponent} from './fournisseur/certif-fournisseur/list-filter-certiffour/list-filter-certiffour.component';
import {
    FilterNomprenCertifComponent
} from './fournisseur/certif-fournisseur/list-filter-certiffour/filter-nompren-certif/filter-nompren-certif.component';
import {
    TableNomprCertiffourComponent
} from './fournisseur/certif-fournisseur/list-filter-certiffour/table-nompr-certiffour/table-nompr-certiffour.component';
import {AddInfogCertifComponent} from './fournisseur/add-certif-fournisseur/add-infog-certif/add-infog-certif.component';
import {AddInfoUserComponent} from './fournisseur/add-certif-fournisseur/add-info-user/add-info-user.component';
import {AddAttributionDroitComponent} from './fournisseur/add-certif-fournisseur/add-attribution-droit/add-attribution-droit.component';
import {ComboAcheteurEtatComponent} from './etat-demande/combo-acheteur-etat/combo-acheteur-etat.component';
import {DetailEtatAcheteurComponent} from './etat-demande/detail-etat-acheteur/detail-etat-acheteur.component';
import {AnnulerDemandeAchComponent} from './etat-demande/annuler-demande-ach/annuler-demande-ach.component';
import {AddCertifAcheteurComponent} from './acheteur/add-certif-acheteur/add-certif-acheteur.component';
import {ListCertifAcheteurComponent} from './acheteur/list-certif-acheteur/list-certif-acheteur.component';
import {
    DialogRenouvelerCertifComponent
} from './fournisseur/certif-fournisseur/dialog-renouveler-certif/dialog-renouveler-certif.component';
import {EtatAgrementFourComponent} from './fournisseur/etat-inscription-fourn/etat-agrement-four/etat-agrement-four.component';
import {
    EtatClassificationFourComponent
} from './fournisseur/etat-inscription-fourn/etat-classification-four/etat-classification-four.component';
import {EtatDetailsFourComponent} from './fournisseur/etat-inscription-fourn/etat-details-four/etat-details-four.component';
import {EtatGeneralFourComponent} from './fournisseur/etat-inscription-fourn/etat-general-four/etat-general-four.component';
import {EtatInfoFourComponent} from './fournisseur/etat-inscription-fourn/etat-info-four/etat-info-four.component';
import {EtatMandataireFourComponent} from './fournisseur/etat-inscription-fourn/etat-mandataire-four/etat-mandataire-four.component';
import {EtatUsineFourComponent} from './fournisseur/etat-inscription-fourn/etat-usine-four/etat-usine-four.component';
import {EtatInscriptionFournComponent} from './fournisseur/etat-inscription-fourn/etat-inscription-fourn.component';
import {
    DetailsListchahierShopComponent
} from './consultations/consultation-details/details-listchahier-shop/details-listchahier-shop.component';
import {DetailsCahierOffrepComponent} from './offers/offer-details/details-cahier-offrep/details-cahier-offrep.component';
import {AuthModule} from '../auth/auth.module';
import {TableEtatEditionComponent} from './table-etat-edition/table-etat-edition.component';
import {BiblioService} from 'src/app/modules/services/bibliotheque/biblio.service';

@NgModule({
    providers: [
        [
            EtatService,
            QnaService,
            CmisService,
            FaqService,
            StattunepsService,
            ContactService,
            NewsService,
            DatePipe,
            FournisseurDetailService,
            CatalogueService,
            BiblioService,
        ],
    ],
    declarations: [
        SliderImageComponent,
        DocloisComponent,
        ServAssistantComponent,
        SitesutilesComponent,
        AccFooterComponent,
        InputSearchComponent,
        AccueilComponent,
        ConsulationcardsComponent,
        StatistiquesComponent,
        PortailComponent,
        OffersComponent,
        OffersTableComponent,
        OffersFiltreComponent,
        OfferComponent,
        FournisseurComponent,
        AddInformationGeneraleFournisseurComponent,
        AddInfoResponsableComponent,
        AcheteurComponent,
        InscriptionAcheteurComponent,
        AddInfoGeneraleAcheteurComponent,
        AddInfoInterlocuteurUniqueComponent,
        OfferDetailsComponent,
        LotTableComponent,
        TextEllipsisComponent,
        LotDetailsComponent,
        ComboAcheteurComponent,
        ComboCommandeComponent,
        ParticipationTableComponent,
        InfoProdTableComponent,
        ProjetProgTableComponent,
        ProjetProgComponent,
        ProjetProgFiltreComponent,
        ProjetProgDetailsComponent,
        CmisComponent,
        CmisTableComponent,
        CmisFiltreComponent,
        CmisCardComponent,
        FaqComponent,
        FaqTableComponent,
        FaqFiltreComponent,
        FaqCardComponent,
        QnaComponent,
        QnaTableComponent,
        QnaFiltreComponent,
        QnaCardComponent,
        ConsultationsComponent,
        ConsultationTableComponent,
        ConsultationFiltreComponent,
        ConsultationDetailsComponent,
        LotConsultationTableComponent,
        NewsComponent,
        NewsCardComponent,
        NewsFiltreComponent,
        NewsTableComponent,
        ContactTerminologieComponent,
        AdminAnnouncementComponent,
        BuyerAnnouncementComponent,
        BuyerAnnouncementCardComponent,
        FournissuerDetailComponent,
        FournisseurTableComponent,
        FournisseurFiltreComponent,
        BuyerAnnouncementFiltreComponent,
        BuyerAnnouncementTableComponent,
        AdminAnnouncementCardComponent,
        AdminAnnouncementFiltreComponent,
        AdminAnnouncementTableComponent,
        AddInfoUsineComponent,
        TableUsineComponent,
        AddDialogUsineComponent,
        AdminAnnouncementTableComponent,
        TousLesStatistiquesComponent,
        AddInfoProduitComponent,
        ProduitTableComponent,
        AddDialogProduitComponent,

        AgrementTableComponent,

        AddDialogAgrementComponent,

        MandataireTableComponent,

        AddDialogMandataireComponent,
        TousLesStatistiquesComponent,
        AnnonceCardsComponent,
        LoginComponent,
        ComboYearsComponent,
        EditDialogUsineComponent,
        EditDialogProduitComponent,
        DialogEditAgrementComponent,
        EditDialogMandataireComponent,
        DetailAgrementComponent,
        DetailMandataireComponent,
        CustomDatePipe,
        EtatDemandeComponent,
        ComboPmeComponent,
        RecapInscrptionAcheteurComponent,
        RecapInfoGeneralAcheteurComponent,
        RecapInscriptionFournisseurComponent,
        RecapInfoGeneralFournisseurComponent,
        CataloguePComponent,
        CataloguePTableComponent,
        CataloguePFiltreComponent,
        CatalogueDetailComponent,
        HierachieClassPComponent,
        HierachiePTreeComponent,
        HierachiePTableComponent,
        DetailProdPComponent,
        CatalogueClassPComponent,
        CatClasPTableComponent,
        CatClasPFiltreComponent,
        CatClasPDetailComponent,
        CatClasPListComponent,
        CatClasPListTableComponent,
        FicheListSoumissionairesComponent,
        TableCommunPortailComponent,
        FicheResultatOuvertureComponent,
        FicheDetailsRequeteComponent,
        AddCertifFournisseurComponent,
        CertifFournisseurComponent,
        FilterCertifFournisseurComponent,
        ListFilterCertiffourComponent,
        FilterNomprenCertifComponent,
        TableNomprCertiffourComponent,
        AddInfogCertifComponent,
        AddInfoUserComponent,
        AddAttributionDroitComponent,
        ComboAcheteurEtatComponent,
        DetailEtatAcheteurComponent,
        AnnulerDemandeAchComponent,
        AddCertifAcheteurComponent,
        ListCertifAcheteurComponent,
        DialogRenouvelerCertifComponent,
        EtatAgrementFourComponent,
        EtatClassificationFourComponent,
        EtatDetailsFourComponent,
        EtatGeneralFourComponent,
        EtatInfoFourComponent,
        EtatMandataireFourComponent,
        EtatUsineFourComponent,
        EtatInscriptionFournComponent,
        DetailsListchahierShopComponent,
        DetailsCahierOffrepComponent,
        TableEtatEditionComponent,
    ],
    imports: [
        MDBBootstrapModule.forRoot(),
        CommonModule,
        PortailRoutingModule,
        WidgetModule,
        CarouselModule,
        ButtonModule,
        MatCardModule,
        MatExpansionModule,
        OwlModule,
        WavesModule,
        MatTableModule,
        MatMenuModule,
        MatToolbarModule,
        FlexLayoutModule,
        MatButtonModule,
        DirectiveModule,
        WidgetModule,
        PipeModule,
        DirectiveModule,
        TranslateModule,
        MatIconModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatPaginatorModule,
        MatStepperModule,
        ScrollingModule,
        MatPaginatorModule,
        MatSortModule,
        MatDialogModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatSelectFilterModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        AuthModule,
    ],
    exports: [
        OffersFiltreComponent,
        OffersTableComponent,
        EtatClassificationFourComponent,
        EtatAgrementFourComponent,
        EtatMandataireFourComponent,
        EtatUsineFourComponent,
        EtatGeneralFourComponent,
          ComboAcheteurComponent,
        ComboAcheteurComponent,

    ],
})
export class PortailModule {
}
